<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
// import '../static/qt'
export default {
  data() {
    return {};
  },

  methods: {},

  computed: {},
  created() {},
  mounted() {},
  watch: {},
  beforeDestroy() {}
};
</script>

<style>
#app {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue